import { render, staticRenderFns } from "./ConsultaLegislacao.vue?vue&type=template&id=71bae43f"
import script from "./ConsultaLegislacao.vue?vue&type=script&lang=ts"
export * from "./ConsultaLegislacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports